import { render, staticRenderFns } from "./NewStockOrder.vue?vue&type=template&id=779c00b5"
import script from "./NewStockOrder.vue?vue&type=script&lang=ts"
export * from "./NewStockOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports